"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const redux_1 = require("redux");
const react_redux_1 = require("react-redux");
const events_1 = require("@dialogexe/cw-website-store/events");
const CultureScheduleList_1 = require("./CultureScheduleList");
require("moment/locale/nb");
class CultureSchedule extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            active: {
                date: '',
                events: null
            },
            days: []
        };
        this.setActiveDay = (day) => {
            if (typeof day === 'undefined') {
                return;
            }
            this.setState({
                active: {
                    date: day.date,
                    events: this.props.events.sort((a, b) => moment(a.startDate).unix() - moment(b.startDate).unix())
                }
            });
        };
        moment.locale('nb');
    }
    componentWillMount() {
        this.props.eventActions.fetchEvents(this.props.events.map(e => e.id));
        const days = this.props.events.reduce((days, next) => {
            if (days.length && days.find(d => moment(next.startDate).isSame(d.date, 'day'))) {
                return days;
            }
            if (moment(next.startDate).startOf('day').isSameOrAfter(moment().startOf('day'))) {
                days.push({
                    date: next.startDate
                });
            }
            return days;
        }, []).sort((a, b) => moment(a.date).unix() - moment(b.date).unix());
        if (days.length === 0) {
            return this.setState({ active: { date: '', events: [] } });
        }
        const activeDay = days[0];
        this.setState({
            days
        }, () => this.setActiveDay(activeDay));
    }
    render() {
        const { title, showTicketCount } = this.props;
        const { active, days } = this.state;
        return (React.createElement("div", { className: "Schedule" },
            React.createElement("h1", { className: "title" }, title),
            React.createElement(CultureScheduleList_1.CultureScheduleList, { date: active.date, events: active.events, showTicketCount: showTicketCount })));
    }
}
exports.CultureSchedule = CultureSchedule;
function merge(newEvents, currentEvents) {
    if (newEvents.length === 0) {
        return currentEvents;
    }
    return currentEvents.map(e => {
        const newEvent = newEvents.find(ne => ne.key === e.id);
        if (!newEvent) {
            return e;
        }
        e.ticketCountLow = newEvent.almost_sold_out;
        e.ticketCount = newEvent.ticket_left_count;
        e.ticketSalesEnabled = newEvent.ticket_sales_enabled;
        e.ticketSalesActive = newEvent.ticket_sales_active;
        return e;
    });
}
exports.default = react_redux_1.connect((state, ownProps) => ({
    events: merge(state.events.items, ownProps.events)
}), (dispatch) => ({
    eventActions: redux_1.bindActionCreators(events_1.actionCreators, dispatch)
}))(CultureSchedule);



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-culture-schedule/CultureSchedule.tsx